export default {
  en: {
    '仓位': 'Position',
    '最小': 'Minimum',
    '成功': 'Success',
    '已关闭': 'Closed',
    '已启动': 'Started',
    '请先绑定': 'Bind first',
    '确定要关闭': 'Confirm turning off',
    '状态': 'Status',
    '币种一': 'Coin 1',
    '币种二': 'Coin 2',
    '不得小于投入金额': 'Cannot be less than the investment amount',
    '马丁策略金额、倍数或做单数量不在有效范围': 'Martingale amount, multiplier, or order count is outside the valid range',
    '请输入有效金额': 'Enter a valid amount',
    '暂未绑定': 'Not bound',
    '已设置': 'Set',
    'API 已绑定，请使用重新绑定': 'API is already bound. Use Rebind',
    '绑定后即可在': 'After binding, you can start a bot on',
    '启动机器人': 'Start bot',
    '绑定于': 'Bound on',
    '最近同步': 'Last synced',
    '验证码已发送到您的邮箱请注意查收': 'A verification code was sent to your email. Please check it',
    '验证码已发送到您的手机请注意查收': 'A verification code was sent to your phone. Please check it',
    'API 绑定失败': 'API binding failed',
    'API 解绑失败': 'API unbinding failed',
    'API 信息读取失败': 'Failed to load API information',
    '绑定交易所 API': 'Bind exchange API',
    '修改交易所 API': 'Update exchange API',
    '确认绑定': 'Confirm binding',
    '绑定中…': 'Binding…',
    '读取中…': 'Loading…',
    '保存中…': 'Saving…',
    '处理中…': 'Processing…',
    '提交中…': 'Submitting…',
    '修改中…': 'Updating…',
    '编辑资料': 'Edit profile',
    '个人资料、账户安全与交易所 API 绑定': 'Profile, account security, and exchange API binding',
    '账户安全': 'Account security',
    '最近登录': 'Last login',
    '登录密码': 'Login password',
    '修改登录密码': 'Change login password',
    '原登录密码': 'Current password',
    '新登录密码': 'New password',
    '确认新密码': 'Confirm new password',
    '再次输入新密码': 'Enter the new password again',
    '显示原登录密码': 'Show current password',
    '隐藏原登录密码': 'Hide current password',
    '显示新登录密码': 'Show new password',
    '隐藏新登录密码': 'Hide new password',
    '显示确认密码': 'Show confirmation password',
    '隐藏确认密码': 'Hide confirmation password',
    '密码安全性': 'Password strength',
    '请输入原登录密码': 'Enter your current password',
    '至少 8 位，含大小写字母、数字和符号': 'At least 8 characters with uppercase and lowercase letters, numbers, and symbols',
    '需为 8-32 位，并同时包含大小写字母、数字和特殊字符': 'Must be 8–32 characters and include uppercase and lowercase letters, numbers, and special characters',
    '两次输入的新密码不一致': 'The two new passwords do not match',
    '新密码不能与原密码相同': 'The new password cannot be the same as the current password',
    '新密码需为 8-32 位，包含大小写字母、数字和特殊字符': 'The new password must be 8–32 characters and include uppercase and lowercase letters, numbers, and special characters',
    '修改成功后需重新登录，且 24 小时内暂停提现，以保障资产安全。': 'You must log in again after the change. Withdrawals will be suspended for 24 hours to protect your assets.',
    '登录密码已修改，请重新登录': 'Login password changed. Please log in again',
    '登录密码修改失败': 'Failed to change login password',
    '未找到登录账号': 'Login account not found',
    '昵称不能为空': 'Nickname is required',
    '昵称需为 2-16 个字符': 'Nickname must be 2–16 characters',
    '2-16 个字符': '2–16 characters',
    '资料已保存': 'Profile saved',
    '资料保存失败': 'Failed to save profile',
    '昵称保存失败': 'Failed to save nickname',
    '头像保存失败': 'Failed to save avatar',
    '头像仅支持 JPG 或 PNG 图片': 'Only JPG or PNG avatar images are supported',
    '头像图片不能超过 4MB': 'Avatar image cannot exceed 4 MB',
    '邀请码已复制': 'Invitation code copied',
    '复制失败': 'Copy failed',
    '复制失败，请手动复制邀请码': 'Copy failed. Please copy the invitation code manually',
    '未绑定接收账号': 'No receiving account is bound',
    '当前交易所 API 均已绑定': 'All exchange APIs are already bound',
    '未找到对应交易所': 'Exchange not found',
    '请输入Api Key': 'Enter API Key',
    '请输入Api Secret': 'Enter API Secret',
    '请输入密码短语': 'Enter Passphrase',
    '请粘贴 API Key': 'Paste API Key',
    '请粘贴 API Secret': 'Paste API Secret',
    'OKX API 创建时设置的口令': 'Passphrase set when creating the OKX API',
    '生态成熟，支持现货与合约策略': 'Mature ecosystem supporting spot and contract strategies',
    '合约品类齐全，需额外填写 Passphrase': 'Wide range of contracts; Passphrase is required',
    '币种覆盖广，适合小市值网格策略': 'Broad coin coverage, suitable for small-cap grid strategies',
    '合约撮合速度快，适合高频策略': 'Fast contract matching, suitable for high-frequency strategies',
    '机器人数量暂不可用': 'Bot count temporarily unavailable',
    '暂无机器人使用': 'No bots are using this API',
    '确认操作': 'Confirm action',
    '保证金健康度': 'Margin health',
    '策略版本': 'Strategy version',
    '策略模式': 'Strategy mode',
    '策略详情读取失败': 'Failed to load strategy details',
    '策略操作成功，详情已重新同步': 'Strategy action completed and details resynced',
    '策略操作失败': 'Strategy action failed',
    '成交明细': 'Trade details',
    '成交明细读取失败': 'Failed to load trade details',
    '持仓方向': 'Position direction',
    '仓位比例': 'Position ratio',
    '初始资产': 'Initial assets',
    '待成交': 'Pending execution',
    '单币策略': 'Single-coin strategy',
    '单向': 'One-way',
    '当前策略收益曲线': 'Current strategy earnings curve',
    '当前策略正在执行补仓操作，请稍候': 'The strategy is adding a position. Please wait',
    '当前策略正在执行清仓操作，请稍候': 'The strategy is closing positions. Please wait',
    '当前没有挂单': 'No open orders',
    '当前没有可展示的记录': 'No records to display',
    '当前行情': 'Current market price',
    '当前月份': 'Current month',
    '当前资产': 'Current assets',
    '等距': 'Equal spacing',
    '低风险': 'Low risk',
    '中风险': 'Medium risk',
    '高风险': 'High risk',
    '风险等级': 'Risk level',
    '需关注': 'Needs attention',
    '多仓': 'Long position',
    '空仓': 'Short position',
    '方向未返回': 'Direction unavailable',
    '风险未返回': 'Risk unavailable',
    '状态未返回': 'Status unavailable',
    '价格上限': 'Upper price',
    '价格下限': 'Lower price',
    '交易标的': 'Trading instrument',
    '交易所余额': 'Exchange balance',
    '金字塔': 'Pyramid',
    '开启补单': 'Enable additional orders',
    '停止补单': 'Stop additional orders',
    '平多': 'Close long',
    '平空': 'Close short',
    '平均开仓价': 'Average entry price',
    '平均平仓价': 'Average close price',
    '强平价格': 'Liquidation price',
    '年化收益率': 'Annualized return',
    '首单金额': 'Initial order amount',
    '刷新详情': 'Refresh details',
    '完成交易': 'Completed trades',
    '完成时间': 'Completion time',
    '委托金额': 'Order amount',
    '委托与成交记录': 'Order and trade records',
    '未实现盈亏': 'Unrealized P&L',
    '已撤销': 'Cancelled',
    '已成交': 'Filled',
    '已平仓数量': 'Closed quantity',
    '已用资金': 'Funds used',
    '已暂停 · 机器人关闭': 'Paused · Bot off',
    '盈利不设限': 'Unlimited profit',
    '永续合约': 'Perpetual contract',
    '正在读取仓位…': 'Loading positions…',
    '正在读取当前挂单…': 'Loading open orders…',
    '正在读取记录…': 'Loading records…',
    '正在读取收益数据…': 'Loading earnings data…',
    '追踪补仓': 'Trailing position addition',
    '追踪止盈': 'Trailing take profit',
    '最大补单次数': 'Maximum additional orders',
    '最大持仓': 'Maximum position',
    '当前币种投入金额': 'Current coin investment',
    '补仓金额': 'Position addition amount',
    'OKX 马丁策略首单额度': 'OKX Martingale first-order amount',
    '昨天': 'Yesterday',
    '请输入价格': 'Enter a price',
    '请输入补仓金额': 'Enter the position addition amount',
    '请输入有效的补仓金额': 'Enter a valid position addition amount',
    '请输入有效的成交价格': 'Enter a valid execution price',
    '补仓金额超过交易所可用余额': 'Position addition exceeds the exchange available balance',
    '补仓校验数据读取失败': 'Failed to load position addition validation data',
    '请确认补仓金额，提交后将按当前行情执行。': 'Confirm the position addition amount. It will execute at the current market price after submission.',
    '确认本次循环停止继续补单？已有委托和持仓不会自动撤销。': 'Stop adding orders for this cycle? Existing orders and positions will not be cancelled automatically.',
    '确认恢复当前马丁策略的自动补单？': 'Resume automatic additional orders for the current Martingale strategy?',
    '确认清仓卖出本次循环的持仓？': 'Close and sell the positions in this cycle?',
    '0 表示无限': '0 means unlimited',
    '仓位币种': 'Position coin',
    '可只填写一侧': 'You may fill in only one side',
    '例如：合约AI · BTC 趋势 2 号': 'Example: Contract AI · BTC Trend No. 2',
    '启动新机器人': 'Start a new bot',
    '启动中…': 'Starting…',
    '确认启动': 'Confirm start',
    '正在读取交易对…': 'Loading trading pairs…',
    '输入币种或交易对筛选': 'Filter by coin or trading pair',
    '输入币种名称筛选': 'Filter by coin name',
    '当前没有可创建策略的币种': 'No coins are available for this strategy',
    '当前交易所尚未绑定有效 API': 'The current exchange does not have a valid bound API',
    '当前交易所暂不可用': 'The current exchange is temporarily unavailable',
    '机器人状态暂不可用，不能创建策略': 'Bot status is unavailable, so the strategy cannot be created',
    '交易所可用资金不足': 'Insufficient available funds on the exchange',
    '请输入投入金额': 'Enter the investment amount',
    '请输入有效的投入金额': 'Enter a valid investment amount',
    '请输入首单倍数': 'Enter the initial order multiplier',
    '请输入首单额度': 'Enter the initial order amount',
    '请输入止损比例': 'Enter the stop-loss ratio',
    '请输入止盈比例': 'Enter the take-profit ratio',
    '请输入止盈回调': 'Enter the take-profit callback',
    '请输入最大持仓金额，或选择“无限”': 'Enter the maximum position amount or select “Unlimited”',
    '请输入最低价': 'Enter the lowest price',
    '请输入最高价': 'Enter the highest price',
    '请输入做单数量': 'Enter the number of orders',
    '请完整填写马丁策略参数': 'Complete all Martingale strategy parameters',
    '请选择交易所': 'Select an exchange',
    '请选择完整的现货交易对': 'Select a complete spot trading pair',
    '请至少填写一侧投入金额': 'Enter an investment amount for at least one side',
    '请至少填写一侧有效仓位': 'Enter a valid position for at least one side',
    '网格数量必须是 2 到 150 之间的整数': 'Grid count must be an integer from 2 to 150',
    '网格最高价必须大于最低价': 'The grid high price must be greater than the low price',
    '补亏损比例应在 0 到 100 之间': 'Loss recovery ratio must be between 0 and 100',
    '不得小于本次投入金额': 'Cannot be less than the current investment amount',
    '最大持仓金额不能小于本次投入金额': 'Maximum position cannot be less than the current investment amount',
    '满单仓位不能超过 9,999,999,999 USDT': 'Full-order position cannot exceed 9,999,999,999 USDT',
    '账户划转': 'Account transfer',
    '转出账户': 'From account',
    '转入账户': 'To account',
    '转出': 'From',
    '转入': 'To',
    '充值网络': 'Deposit network',
    '资金账户与燃料账户之间划转': 'Transfer between the funding and fuel accounts',
    '可用余额：': 'Available balance:',
    '确认划转': 'Confirm transfer',
    '划转金额不能超过可用余额': 'Transfer amount cannot exceed the available balance',
    '转入和转出账户不能相同': 'The source and destination accounts cannot be the same',
    '资金账户余额不足': 'Insufficient funding account balance',
    '提现 USDT': 'Withdraw USDT',
    '请仔细核对目标地址与验证码': 'Carefully verify the destination address and verification code',
    '请输入 USDT 钱包地址': 'Enter a USDT wallet address',
    '可提现金额尚未加载': 'Withdrawable amount has not loaded yet',
    '提现金额不能超过可提现金额': 'Withdrawal amount cannot exceed the withdrawable amount',
    '选择提现方式': 'Select withdrawal method',
    '资金将从资金账户转出，请选择到账方式': 'Funds will be deducted from the funding account. Select a destination method',
    '链上提现': 'On-chain withdrawal',
    '链上提现 USDT': 'Withdraw USDT on-chain',
    '提现至 Tron (TRC20) 钱包地址': 'Withdraw to a Tron (TRC20) wallet address',
    '内部转账': 'Internal transfer',
    '转至其他 UPlus 用户的资金账户，免手续费': 'Transfer to another UPlus user’s funding account with no fee',
    '转至其他 UPlus 用户的资金账户': 'Transfer to another UPlus user’s funding account',
    '确认转账': 'Confirm transfer',
    '收款账户类型': 'Recipient account type',
    '手机号': 'Phone number',
    '邮箱': 'Email',
    '对方 UPlus 平台账户': 'Recipient UPlus account',
    '请输入对方邮箱': 'Enter the recipient email',
    '请输入对方手机号': 'Enter the recipient phone number',
    '转账金额': 'Transfer amount',
    '手续费': 'Fee',
    '限时免费': 'Fee waived',
    '接收账号': 'Verification account',
    '请输入对方账户': 'Enter the recipient account',
    '邮箱格式不正确': 'Invalid email format',
    '手机号格式不正确': 'Invalid phone number format',
    '不能转账给自己': 'You cannot transfer to your own account',
    '请输入转账金额': 'Enter the transfer amount',
    '转账金额不能超过资金账户余额': 'Transfer amount cannot exceed the funding account balance',
    '请选择购买额度': 'Select a purchase amount',
    '当前购买额度无效': 'The selected purchase amount is invalid',
    '恢复机器人策略': 'Resume bot strategy',
    '暂停机器人策略': 'Pause bot strategy',
    '删除机器人策略': 'Delete bot strategy',
    '修改机器人策略': 'Edit bot strategy',
    '请确认本次策略操作': 'Confirm this strategy action',
    '确认恢复': 'Confirm resume',
    '确认暂停': 'Confirm pause',
    '确认删除': 'Confirm deletion',
    '确认恢复当前策略？': 'Resume the current strategy?',
    '确认暂停当前策略？': 'Pause the current strategy?',
    '恢复后机器人会继续按照当前参数监控并执行交易。': 'After resuming, the bot will continue monitoring and trading with the current parameters.',
    '暂停后不会再创建新的委托，现有挂单和持仓按交易所实际状态保留。': "While paused, no new orders will be placed. Existing open orders and positions remain subject to the exchange's actual status.",
    '确认删除当前策略？': 'Delete the current strategy?',
    '删除后机器人将不再监控该策略，未撤销的挂单和持仓可能仍需在交易所处理。': 'After deletion, the bot will stop monitoring this strategy. Open orders and positions that have not been canceled may still require handling on the exchange.',
    '删除策略，不撤销挂单': 'Delete strategy without canceling orders',
    '保留交易所当前挂单和持仓，由你手动处理。': 'Keep the current exchange orders and positions for manual handling.',
    '删除策略并撤销挂单': 'Delete strategy and cancel orders',
    '同时撤销当前挂单，已成交订单不受影响。': 'Cancel current open orders as well. Filled orders are not affected.',
    '支付账户 · 交易所账户': 'Payment account · Exchange account',
    '● 风险保护已启用：自动止损、保证金监控与异常告警将同步生效。': '● Risk protection enabled: automatic stop-loss, margin monitoring, and anomaly alerts take effect together.',
    '修改后新参数将立即生效': 'The new parameters take effect immediately',
    '请输入修改后的投入金额': 'Enter the updated investment amount',
    '请输入修改后仓位': 'Enter the updated position',
    '请输入最大持仓': 'Enter the maximum position',
    '请输入有效的最大持仓金额': 'Enter a valid maximum position amount',
    '最大持仓不能小于投入金额': 'Maximum position cannot be less than the investment amount',
    '状态未知': 'Unknown status',
    'Astra 策略投入金额不能低于 100 USDT': 'Astra strategy investment cannot be less than 100 USDT',
    'Binance U 本位合约可用资金不能低于仓位的 30%': 'Available Binance USDⓈ-M contract funds cannot be less than 30% of the position',
    'Binance 单网格利润率必须大于 1%': 'Binance single-grid profit rate must be greater than 1%',
    'Binance 马丁策略首单额度不能低于 15 USDT': 'The first Binance Martingale order cannot be less than 15 USDT',
    'Binance 现货可用资金不能低于仓位的 70%': 'Available Binance spot funds cannot be less than 70% of the position',
    'OKX 单网格利润率必须大于 0%': 'OKX single-grid profit rate must be greater than 0%',
    '首单额度、首单倍数和做单数量必须为有效正数': 'Initial order amount, multiplier, and order count must be valid positive numbers',
    '正在读取机器人状态、可用名额、交易所余额与策略参数…': 'Loading bot status, available quota, exchange balance, and strategy parameters…',
    '止盈、回调和满单止损比例不在有效范围': 'Take-profit, callback, or full-position stop-loss ratio is outside the valid range',
    '币币交易': 'Spot trading',
    '该策略暂无收益曲线': 'No earnings curve is available for this strategy',
    '模式': 'Mode',
    '开启': 'Enable',
    '保证金余额': 'Margin balance',
    '初始保证金': 'Initial margin',
    '浮动盈亏': 'Floating P&L',
    '今日收益': 'Today earnings',
    '累计峰值': 'Cumulative peak',
    '投入金额': 'Investment amount',
    '总收益': 'Total earnings'
  },
  ko: {
    '仓位': '포지션',
    '最小': '최소',
    '成功': '성공',
    '已关闭': '종료됨',
    '已启动': '시작됨',
    '请先绑定': '먼저 연결해 주세요',
    '确定要关闭': '종료 확인',
    '状态': '상태',
    '币种一': '코인 1',
    '币种二': '코인 2',
    '不得小于投入金额': '투자 금액보다 작을 수 없습니다',
    '马丁策略金额、倍数或做单数量不在有效范围': '마틴 금액, 배수 또는 주문 수가 유효 범위를 벗어났습니다',
    '请输入有效金额': '유효한 금액을 입력하세요',
    '暂未绑定': '연결되지 않음',
    '已设置': '설정됨',
    'API 已绑定，请使用重新绑定': 'API가 이미 연결되어 있습니다. 다시 연결을 사용하세요',
    '绑定后即可在': '연결 후 봇을 시작할 수 있는 거래소:',
    '启动机器人': '봇 시작',
    '绑定于': '연결일',
    '最近同步': '최근 동기화',
    '验证码已发送到您的邮箱请注意查收': '인증 코드가 이메일로 전송되었습니다. 확인하세요',
    '验证码已发送到您的手机请注意查收': '인증 코드가 휴대전화로 전송되었습니다. 확인하세요',
    'API 绑定失败': 'API 연결 실패',
    'API 解绑失败': 'API 연결 해제 실패',
    'API 信息读取失败': 'API 정보를 불러오지 못했습니다',
    '绑定交易所 API': '거래소 API 연결',
    '修改交易所 API': '거래소 API 수정',
    '确认绑定': '연결 확인',
    '绑定中…': '연결 중…',
    '读取中…': '불러오는 중…',
    '保存中…': '저장 중…',
    '处理中…': '처리 중…',
    '提交中…': '제출 중…',
    '修改中…': '수정 중…',
    '编辑资料': '프로필 편집',
    '个人资料、账户安全与交易所 API 绑定': '프로필, 계정 보안 및 거래소 API 연결',
    '账户安全': '계정 보안',
    '最近登录': '최근 로그인',
    '登录密码': '로그인 비밀번호',
    '修改登录密码': '로그인 비밀번호 변경',
    '原登录密码': '현재 비밀번호',
    '新登录密码': '새 비밀번호',
    '确认新密码': '새 비밀번호 확인',
    '再次输入新密码': '새 비밀번호를 다시 입력하세요',
    '显示原登录密码': '현재 비밀번호 표시',
    '隐藏原登录密码': '현재 비밀번호 숨기기',
    '显示新登录密码': '새 비밀번호 표시',
    '隐藏新登录密码': '새 비밀번호 숨기기',
    '显示确认密码': '확인 비밀번호 표시',
    '隐藏确认密码': '확인 비밀번호 숨기기',
    '密码安全性': '비밀번호 보안 수준',
    '请输入原登录密码': '현재 비밀번호를 입력하세요',
    '至少 8 位，含大小写字母、数字和符号': '8자 이상이며 대문자, 소문자, 숫자와 기호를 포함',
    '需为 8-32 位，并同时包含大小写字母、数字和特殊字符': '8~32자이며 대문자, 소문자, 숫자와 특수문자를 모두 포함해야 합니다',
    '两次输入的新密码不一致': '두 새 비밀번호가 일치하지 않습니다',
    '新密码不能与原密码相同': '새 비밀번호는 현재 비밀번호와 같을 수 없습니다',
    '新密码需为 8-32 位，包含大小写字母、数字和特殊字符': '새 비밀번호는 8~32자이며 대문자, 소문자, 숫자와 특수문자를 포함해야 합니다',
    '修改成功后需重新登录，且 24 小时内暂停提现，以保障资产安全。': '변경 후 다시 로그인해야 하며 자산 보호를 위해 24시간 동안 출금이 중지됩니다.',
    '登录密码已修改，请重新登录': '로그인 비밀번호가 변경되었습니다. 다시 로그인하세요',
    '登录密码修改失败': '로그인 비밀번호 변경 실패',
    '未找到登录账号': '로그인 계정을 찾을 수 없습니다',
    '昵称不能为空': '닉네임을 입력하세요',
    '昵称需为 2-16 个字符': '닉네임은 2~16자여야 합니다',
    '2-16 个字符': '2~16자',
    '资料已保存': '프로필이 저장되었습니다',
    '资料保存失败': '프로필 저장 실패',
    '昵称保存失败': '닉네임 저장 실패',
    '头像保存失败': '프로필 이미지 저장 실패',
    '头像仅支持 JPG 或 PNG 图片': '프로필 이미지는 JPG 또는 PNG만 지원합니다',
    '头像图片不能超过 4MB': '프로필 이미지는 4MB를 초과할 수 없습니다',
    '邀请码已复制': '초대 코드가 복사되었습니다',
    '复制失败': '복사 실패',
    '复制失败，请手动复制邀请码': '복사에 실패했습니다. 초대 코드를 직접 복사하세요',
    '未绑定接收账号': '수신 계정이 연결되지 않았습니다',
    '当前交易所 API 均已绑定': '모든 거래소 API가 이미 연결되었습니다',
    '未找到对应交易所': '거래소를 찾을 수 없습니다',
    '请输入Api Key': 'API Key를 입력하세요',
    '请输入Api Secret': 'API Secret을 입력하세요',
    '请输入密码短语': 'Passphrase를 입력하세요',
    '请粘贴 API Key': 'API Key를 붙여넣으세요',
    '请粘贴 API Secret': 'API Secret을 붙여넣으세요',
    'OKX API 创建时设置的口令': 'OKX API 생성 시 설정한 Passphrase',
    '生态成熟，支持现货与合约策略': '성숙한 생태계로 현물 및 계약 전략 지원',
    '合约品类齐全，需额外填写 Passphrase': '다양한 계약 상품을 지원하며 Passphrase 입력 필요',
    '币种覆盖广，适合小市值网格策略': '다양한 코인을 지원하여 소형 코인 그리드 전략에 적합',
    '合约撮合速度快，适合高频策略': '빠른 계약 체결로 고빈도 전략에 적합',
    '机器人数量暂不可用': '봇 수를 현재 확인할 수 없습니다',
    '暂无机器人使用': '이 API를 사용하는 봇이 없습니다',
    '确认操作': '작업 확인',
    '保证金健康度': '증거금 건전성',
    '策略版本': '전략 버전',
    '策略模式': '전략 모드',
    '策略详情读取失败': '전략 상세를 불러오지 못했습니다',
    '策略操作成功，详情已重新同步': '전략 작업이 완료되어 상세 정보가 다시 동기화되었습니다',
    '策略操作失败': '전략 작업 실패',
    '成交明细': '체결 내역',
    '成交明细读取失败': '체결 내역을 불러오지 못했습니다',
    '持仓方向': '포지션 방향',
    '仓位比例': '포지션 비율',
    '初始资产': '초기 자산',
    '待成交': '체결 대기',
    '单币策略': '단일 코인 전략',
    '单向': '단방향',
    '当前策略收益曲线': '현재 전략 수익 곡선',
    '当前策略正在执行补仓操作，请稍候': '전략이 포지션을 추가하고 있습니다. 잠시 기다리세요',
    '当前策略正在执行清仓操作，请稍候': '전략이 포지션을 청산하고 있습니다. 잠시 기다리세요',
    '当前没有挂单': '현재 미체결 주문이 없습니다',
    '当前没有可展示的记录': '표시할 기록이 없습니다',
    '当前行情': '현재 시장가',
    '当前月份': '현재 월',
    '当前资产': '현재 자산',
    '等距': '동일 간격',
    '低风险': '낮은 위험',
    '中风险': '중간 위험',
    '高风险': '높은 위험',
    '风险等级': '위험 등급',
    '需关注': '관심 필요',
    '多仓': '롱 포지션',
    '空仓': '숏 포지션',
    '方向未返回': '방향 정보 없음',
    '风险未返回': '위험 정보 없음',
    '状态未返回': '상태 정보 없음',
    '价格上限': '상한가',
    '价格下限': '하한가',
    '交易标的': '거래 대상',
    '交易所余额': '거래소 잔액',
    '金字塔': '피라미드',
    '开启补单': '추가 주문 켜기',
    '停止补单': '추가 주문 중지',
    '平多': '롱 청산',
    '平空': '숏 청산',
    '平均开仓价': '평균 진입가',
    '平均平仓价': '평균 청산가',
    '强平价格': '강제 청산가',
    '年化收益率': '연환산 수익률',
    '首单金额': '첫 주문 금액',
    '刷新详情': '상세 새로고침',
    '完成交易': '완료된 거래',
    '完成时间': '완료 시간',
    '委托金额': '주문 금액',
    '委托与成交记录': '주문 및 체결 기록',
    '未实现盈亏': '미실현 손익',
    '已撤销': '취소됨',
    '已成交': '체결됨',
    '已平仓数量': '청산 수량',
    '已用资金': '사용 자금',
    '已暂停 · 机器人关闭': '일시정지 · 봇 꺼짐',
    '盈利不设限': '수익 제한 없음',
    '永续合约': '무기한 계약',
    '正在读取仓位…': '포지션 로딩 중…',
    '正在读取当前挂单…': '미체결 주문 로딩 중…',
    '正在读取记录…': '기록 로딩 중…',
    '正在读取收益数据…': '수익 데이터 로딩 중…',
    '追踪补仓': '추적 포지션 추가',
    '追踪止盈': '추적 이익 실현',
    '最大补单次数': '최대 추가 주문 횟수',
    '最大持仓': '최대 포지션',
    '当前币种投入金额': '현재 코인 투자 금액',
    '补仓金额': '포지션 추가 금액',
    'OKX 马丁策略首单额度': 'OKX 마틴 첫 주문 금액',
    '昨天': '어제',
    '请输入价格': '가격을 입력하세요',
    '请输入补仓金额': '추가 포지션 금액을 입력하세요',
    '请输入有效的补仓金额': '유효한 추가 포지션 금액을 입력하세요',
    '请输入有效的成交价格': '유효한 체결 가격을 입력하세요',
    '补仓金额超过交易所可用余额': '추가 포지션 금액이 거래소 가용 잔액을 초과합니다',
    '补仓校验数据读取失败': '추가 포지션 검증 데이터를 불러오지 못했습니다',
    '请确认补仓金额，提交后将按当前行情执行。': '추가 포지션 금액을 확인하세요. 제출 후 현재 시장가로 실행됩니다.',
    '确认本次循环停止继续补单？已有委托和持仓不会自动撤销。': '이번 주기의 추가 주문을 중지할까요? 기존 주문과 포지션은 자동 취소되지 않습니다.',
    '确认恢复当前马丁策略的自动补单？': '현재 마틴 전략의 자동 추가 주문을 재개할까요?',
    '确认清仓卖出本次循环的持仓？': '이번 주기의 포지션을 모두 청산할까요?',
    '0 表示无限': '0은 무제한을 의미합니다',
    '仓位币种': '포지션 코인',
    '可只填写一侧': '한쪽만 입력해도 됩니다',
    '例如：合约AI · BTC 趋势 2 号': '예: 계약 AI · BTC 추세 2호',
    '启动新机器人': '새 봇 시작',
    '启动中…': '시작 중…',
    '确认启动': '시작 확인',
    '正在读取交易对…': '거래 페어 로딩 중…',
    '输入币种或交易对筛选': '코인 또는 거래 페어로 필터',
    '输入币种名称筛选': '코인 이름으로 필터',
    '当前没有可创建策略的币种': '이 전략에 사용할 수 있는 코인이 없습니다',
    '当前交易所尚未绑定有效 API': '현재 거래소에 유효한 API가 연결되지 않았습니다',
    '当前交易所暂不可用': '현재 거래소를 일시적으로 사용할 수 없습니다',
    '机器人状态暂不可用，不能创建策略': '봇 상태를 확인할 수 없어 전략을 생성할 수 없습니다',
    '交易所可用资金不足': '거래소 가용 자금이 부족합니다',
    '请输入投入金额': '투자 금액을 입력하세요',
    '请输入有效的投入金额': '유효한 투자 금액을 입력하세요',
    '请输入首单倍数': '첫 주문 배수를 입력하세요',
    '请输入首单额度': '첫 주문 금액을 입력하세요',
    '请输入止损比例': '손절 비율을 입력하세요',
    '请输入止盈比例': '익절 비율을 입력하세요',
    '请输入止盈回调': '익절 콜백을 입력하세요',
    '请输入最大持仓金额，或选择“无限”': '최대 포지션 금액을 입력하거나 “무제한”을 선택하세요',
    '请输入最低价': '최저가를 입력하세요',
    '请输入最高价': '최고가를 입력하세요',
    '请输入做单数量': '주문 수량을 입력하세요',
    '请完整填写马丁策略参数': '마틴 전략 매개변수를 모두 입력하세요',
    '请选择交易所': '거래소를 선택하세요',
    '请选择完整的现货交易对': '완전한 현물 거래 페어를 선택하세요',
    '请至少填写一侧投入金额': '한쪽 이상의 투자 금액을 입력하세요',
    '请至少填写一侧有效仓位': '한쪽 이상의 유효한 포지션을 입력하세요',
    '网格数量必须是 2 到 150 之间的整数': '그리드 수는 2~150 사이의 정수여야 합니다',
    '网格最高价必须大于最低价': '그리드 최고가는 최저가보다 커야 합니다',
    '补亏损比例应在 0 到 100 之间': '손실 보전 비율은 0~100 사이여야 합니다',
    '不得小于本次投入金额': '현재 투자 금액보다 작을 수 없습니다',
    '最大持仓金额不能小于本次投入金额': '최대 포지션은 현재 투자 금액보다 작을 수 없습니다',
    '满单仓位不能超过 9,999,999,999 USDT': '전체 주문 포지션은 9,999,999,999 USDT를 초과할 수 없습니다',
    '账户划转': '계정 이체',
    '转出账户': '출금 계정',
    '转入账户': '입금 계정',
    '转出': '출금',
    '转入': '입금',
    '充值网络': '입금 네트워크',
    '资金账户与燃料账户之间划转': '자금 계정과 연료 계정 간 이체',
    '可用余额：': '가용 잔액:',
    '确认划转': '이체 확인',
    '划转金额不能超过可用余额': '이체 금액은 가용 잔액을 초과할 수 없습니다',
    '转入和转出账户不能相同': '출금 계정과 입금 계정은 같을 수 없습니다',
    '资金账户余额不足': '자금 계정 잔액이 부족합니다',
    '提现 USDT': 'USDT 출금',
    '请仔细核对目标地址与验证码': '대상 주소와 인증 코드를 꼼꼼히 확인하세요',
    '请输入 USDT 钱包地址': 'USDT 지갑 주소를 입력하세요',
    '可提现金额尚未加载': '출금 가능 금액이 아직 로드되지 않았습니다',
    '提现金额不能超过可提现金额': '출금 금액은 출금 가능 금액을 초과할 수 없습니다',
    '选择提现方式': '출금 방식 선택',
    '资金将从资金账户转出，请选择到账方式': '자금 계정에서 출금됩니다. 수령 방식을 선택하세요',
    '链上提现': '온체인 출금',
    '链上提现 USDT': 'USDT 온체인 출금',
    '提现至 Tron (TRC20) 钱包地址': 'Tron (TRC20) 지갑 주소로 출금',
    '内部转账': '내부 이체',
    '转至其他 UPlus 用户的资金账户，免手续费': '다른 UPlus 사용자의 자금 계정으로 수수료 없이 이체',
    '转至其他 UPlus 用户的资金账户': '다른 UPlus 사용자의 자금 계정으로 이체',
    '确认转账': '이체 확인',
    '收款账户类型': '수취 계정 유형',
    '手机号': '휴대폰 번호',
    '邮箱': '이메일',
    '对方 UPlus 平台账户': '상대방 UPlus 계정',
    '请输入对方邮箱': '상대방 이메일을 입력하세요',
    '请输入对方手机号': '상대방 휴대폰 번호를 입력하세요',
    '转账金额': '이체 금액',
    '手续费': '수수료',
    '限时免费': '수수료 면제',
    '接收账号': '인증 수신 계정',
    '请输入对方账户': '상대방 계정을 입력하세요',
    '邮箱格式不正确': '이메일 형식이 올바르지 않습니다',
    '手机号格式不正确': '휴대폰 번호 형식이 올바르지 않습니다',
    '不能转账给自己': '본인 계정으로 이체할 수 없습니다',
    '请输入转账金额': '이체 금액을 입력하세요',
    '转账金额不能超过资金账户余额': '이체 금액은 자금 계정 잔액을 초과할 수 없습니다',
    '请选择购买额度': '구매 금액을 선택하세요',
    '当前购买额度无效': '선택한 구매 금액이 유효하지 않습니다',
    '恢复机器人策略': '봇 전략 재개',
    '暂停机器人策略': '봇 전략 일시정지',
    '删除机器人策略': '봇 전략 삭제',
    '修改机器人策略': '봇 전략 수정',
    '请确认本次策略操作': '전략 작업을 확인하세요',
    '确认恢复': '재개 확인',
    '确认暂停': '일시정지 확인',
    '确认删除': '삭제 확인',
    '确认恢复当前策略？': '현재 전략을 재개할까요?',
    '确认暂停当前策略？': '현재 전략을 일시정지할까요?',
    '恢复后机器人会继续按照当前参数监控并执行交易。': '재개하면 봇이 현재 설정으로 모니터링과 거래를 계속합니다.',
    '暂停后不会再创建新的委托，现有挂单和持仓按交易所实际状态保留。': '일시정지 중에는 새 주문을 생성하지 않습니다. 기존 미체결 주문과 포지션은 거래소의 실제 상태대로 유지됩니다.',
    '确认删除当前策略？': '현재 전략을 삭제할까요?',
    '删除后机器人将不再监控该策略，未撤销的挂单和持仓可能仍需在交易所处理。': '삭제하면 봇이 이 전략을 더 이상 모니터링하지 않습니다. 취소되지 않은 주문과 포지션은 거래소에서 별도로 처리해야 할 수 있습니다.',
    '删除策略，不撤销挂单': '주문을 취소하지 않고 전략 삭제',
    '保留交易所当前挂单和持仓，由你手动处理。': '거래소의 현재 주문과 포지션을 유지하고 직접 처리합니다.',
    '删除策略并撤销挂单': '전략 삭제 및 주문 취소',
    '同时撤销当前挂单，已成交订单不受影响。': '현재 미체결 주문도 함께 취소합니다. 체결된 주문에는 영향을 주지 않습니다.',
    '支付账户 · 交易所账户': '결제 계정 · 거래소 계정',
    '● 风险保护已启用：自动止损、保证金监控与异常告警将同步生效。': '● 위험 보호 활성화: 자동 손절매, 증거금 모니터링, 이상 알림이 함께 적용됩니다.',
    '修改后新参数将立即生效': '새 매개변수는 즉시 적용됩니다',
    '请输入修改后的投入金额': '수정된 투자 금액을 입력하세요',
    '请输入修改后仓位': '수정된 포지션을 입력하세요',
    '请输入最大持仓': '최대 포지션을 입력하세요',
    '请输入有效的最大持仓金额': '유효한 최대 포지션 금액을 입력하세요',
    '最大持仓不能小于投入金额': '최대 포지션은 투자 금액보다 작을 수 없습니다',
    '状态未知': '상태 알 수 없음',
    'Astra 策略投入金额不能低于 100 USDT': 'Astra 전략 투자 금액은 100 USDT 이상이어야 합니다',
    'Binance U 本位合约可用资金不能低于仓位的 30%': 'Binance USDT-M 계약 가용 자금은 포지션의 30% 이상이어야 합니다',
    'Binance 单网格利润率必须大于 1%': 'Binance 단일 그리드 수익률은 1%보다 커야 합니다',
    'Binance 马丁策略首单额度不能低于 15 USDT': 'Binance 마틴 첫 주문은 15 USDT 이상이어야 합니다',
    'Binance 现货可用资金不能低于仓位的 70%': 'Binance 현물 가용 자금은 포지션의 70% 이상이어야 합니다',
    'OKX 单网格利润率必须大于 0%': 'OKX 단일 그리드 수익률은 0%보다 커야 합니다',
    '首单额度、首单倍数和做单数量必须为有效正数': '첫 주문 금액, 배수 및 주문 수는 유효한 양수여야 합니다',
    '正在读取机器人状态、可用名额、交易所余额与策略参数…': '봇 상태, 가용 할당량, 거래소 잔액 및 전략 매개변수 로딩 중…',
    '止盈、回调和满单止损比例不在有效范围': '익절, 콜백 또는 전체 포지션 손절 비율이 유효 범위를 벗어났습니다',
    '币币交易': '현물 거래',
    '该策略暂无收益曲线': '이 전략의 수익 곡선이 없습니다',
    '模式': '모드',
    '开启': '켜기',
    '保证金余额': '증거금 잔액',
    '初始保证金': '초기 증거금',
    '浮动盈亏': '미실현 손익',
    '今日收益': '오늘 수익',
    '累计峰值': '누적 최고값',
    '投入金额': '투자 금액',
    '总收益': '총수익'
  }
}
